import { Layout } from './Layout.js'

export class ProjectInvitationLayout extends Layout {
    template() {
        const { sectionId = '' } = this.$props
        return `
            <section id="${sectionId}" class="signup-wide-pop morningmate-type">
                <header class="js-section-header"></header>
                <article>
                    <div class="js-contents-main pop-main">
                        ${this.getMainTextTemplate()}
                        ${this.getSubTextTemplate()}
                        <div class="corp-process-wrap">
                            <ul>
                                <li id="inviteButtonLayer"></li>
                                <li id="invitationListLayer" class="exist-corp-wrap" style="display: none">
                                    <p>${i18next.t(login.existingTeamDesc)}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </article>
            </section>
        `
    }

    getInviteButtonWrap() {
        return $('#inviteButtonLayer')
    }

    getInvitationListLayer() {
        return $('#invitationListLayer')
    }

    showInvitationListLayer() {
        const $invitationListLayer = this.getInvitationListLayer()
        if ($invitationListLayer.is(':visible')) {
            return
        }
        $invitationListLayer.show()
    }
}